import React from 'react';
import styles from './FavoriteTooltip.module.css';
import PropTypes from 'prop-types';

const FavoriteTooltip = ({ children, text, position = 'top', onClick }) => {
  return (
    <div className={styles.tooltipWrapper} onClick={onClick}>
      {children}
    </div>
  );
};

FavoriteTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
};

export default FavoriteTooltip;
